import React from "react";


function UpcomingHeader() {

    return (
        <>
            <div className="pd-header">

                <div className="header-bottom">
                    <h2 className="pd-title">Pre-register for upcoming workshops!</h2>
                </div>
            </div>
        </>
    );
}

export default UpcomingHeader;
